/**
 * Web mock for react-native-qrcode-svg
 * Provides a simple web-compatible QR code component
 */

import React from 'react';
import { View, Text } from 'react-native';

// Simple QR code placeholder for web
const QRCode = ({ value, size = 200, color = '#000000', backgroundColor = '#FFFFFF', ...props }) => {
  // Use QR code API for web
  const qrCodeUrl = value 
    ? `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(value)}`
    : null;
  
  return (
    <View style={{ width: size, height: size, backgroundColor: backgroundColor || '#FFFFFF', justifyContent: 'center', alignItems: 'center' }}>
      {qrCodeUrl ? (
        <img 
          src={qrCodeUrl} 
          alt="QR Code" 
          style={{ width: size, height: size, display: 'block' }}
          {...props}
        />
      ) : (
        <Text style={{ color: '#999' }}>No QR code data</Text>
      )}
    </View>
  );
};

export default QRCode;

